import { useCallback } from 'react';
import useSlingApi from '@sdk/api/useSlingApi';
import {
  CalendarSpan,
  IntegrationPlatform,
  ToastScheduleImportPageSource,
} from '@sdk/integrations/types';
import { DateString } from '@sdk/types';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';

export const useImportToastShifts = (
  date: DateString,
  displayMode: string,
  currentUser: AuthUserType
) => {
  const slingApi = useSlingApi();

  return useCallback(async () => {
    if (
      currentUser.isManager &&
      currentUser.org.hasToastIntegration &&
      displayMode == CalendarSpan.week
    ) {
      await slingApi.integrations.importShifts(
        IntegrationPlatform.toast,
        date,
        displayMode as CalendarSpan,
        ToastScheduleImportPageSource.scheduleImportBanner
      );
    }
  }, [date, displayMode]);
};
